var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLPlettericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ret\\xE2ngulo_15520",
    x: 0,
    y: 0,
    width: 164,
    height: 164,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65599",
    "data-name": "Grupo 65599",
    transform: "translate(-938 -1949)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 938, 1949)",
    filter: "url(#Ret\\xE2ngulo_15520)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_15520-2",
    "data-name": "Ret\\xE2ngulo 15520",
    width: 104,
    height: 104,
    rx: 4,
    transform: "translate(30 24)",
    fill: "#38d2d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_65574",
    "data-name": "Grupo 65574",
    transform: "translate(3678 8229.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95245",
    "data-name": "Caminho 95245",
    d: "M759.67,181.077a4.379,4.379,0,0,0-5.648-.333l-9.2,6.9a6.2,6.2,0,0,1-7.564,0l-9.214-6.9a4.276,4.276,0,0,0-2.366-.866,4.481,4.481,0,0,0-3.332,1.2,4.344,4.344,0,0,0-1.35,3.166v9.38a9.363,9.363,0,0,0,9.4,9.364h21.26a9.363,9.363,0,0,0,9.364-9.364v-9.38a4.345,4.345,0,0,0-1.349-3.166Zm-1.783,12.546a6.249,6.249,0,0,1-6.231,6.231H730.4a6.249,6.249,0,0,1-6.231-6.231v-9.38a1.228,1.228,0,0,1,.092-.488,1.206,1.206,0,0,1,.275-.412,1.328,1.328,0,0,1,.883-.35,1.272,1.272,0,0,1,.666.25l9.2,6.9a9.4,9.4,0,0,0,11.363,0l9.2-6.9a1.272,1.272,0,0,1,.667-.25,1.316,1.316,0,0,1,.95.35,1.2,1.2,0,0,1,.275.412,1.226,1.226,0,0,1,.092.488v9.38ZM724.932,175.3v-2.932a9.381,9.381,0,0,1,9.43-9.364h13.579a9.378,9.378,0,0,1,9.38,9.364v2.9a1.566,1.566,0,1,1-3.116,0v-2.9a6.263,6.263,0,0,0-6.265-6.231H734.362a6.249,6.249,0,0,0-6.248,6.231v2.9a1.566,1.566,0,1,1-3.132,0Z",
    transform: "translate(-3399 -6387.99)",
    fill: "#142249"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95246",
    "data-name": "Caminho 95246",
    d: "M733.421,180.952v-.2a12.9,12.9,0,0,1-2.049-.616,1.583,1.583,0,0,1-.572-.307,1.574,1.574,0,0,1-.555-1.136,1.574,1.574,0,0,1,.108-.638,1.566,1.566,0,0,1,.9-.888,1.576,1.576,0,0,1,.64-.1,1.552,1.552,0,0,1,.625.168,8.221,8.221,0,0,0,2.666.583.788.788,0,0,0,.553-.23.789.789,0,0,0,.17-.253.816.816,0,0,0,.06-.3c0-.433-.467-.766-1.066-.766a4.116,4.116,0,0,1-4.049-2.323,4.1,4.1,0,0,1-.4-1.593,3.9,3.9,0,0,1,2.966-3.782v-.117a1.566,1.566,0,0,1,3.132,0v.283a10.506,10.506,0,0,1,1.349.45,1.556,1.556,0,0,1-1.133,2.9,6.3,6.3,0,0,0-2.4-.516.78.78,0,0,0-.783.783c0,.45.567.783,1.316.783a4,4,0,0,1,4.182,3.932,3.9,3.9,0,0,1-2.532,3.665v.25a1.566,1.566,0,0,1-3.132,0Z",
    transform: "translate(-3392.842 -6385.398)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLPlettericon);
export default __webpack_public_path__ + "static/media/LPlettericon.7580f516721bde6a1b7fdcb743445ea1.svg";
export { ForwardRef as ReactComponent };